import React from 'react'
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'
import type { ColumnDef, LineItem } from './types'

interface ItemsTableDesktopProps {
  columns: ColumnDef[]
  items: LineItem[]
  renderCell: (item: LineItem, index: number, key: string) => React.ReactNode
}

const ItemsTableDesktop: React.FC<ItemsTableDesktopProps> = ({ columns, items, renderCell }) => {
  return (
    <TableContainer sx={{ 
      maxHeight: { xs: 250, sm: 300 }, 
      border: '2px solid',
      borderColor: 'divider', 
      borderRadius: 3,
      overflowX: 'auto',
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
    }}>
      <Table size="small" stickyHeader sx={{ 
        '& .MuiTableCell-root': { 
          padding: '8px 12px',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            bgcolor: 'action.hover'
          },
          '& .MuiTextField-root': {
            '& .MuiInputBase-root': {
              fontSize: '0.875rem',
              borderRadius: 1,
              '& input': {
                padding: '8px 12px'
              }
            },
            '& .MuiSelect-select': {
              fontSize: '0.875rem',
              padding: '8px 12px !important',
              minHeight: 'unset'
            },
            '& .MuiFormControl-root': {
              minWidth: 'unset'
            }
          }
        }
      }}>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell 
                key={column.key}
                sx={{ 
                  bgcolor: 'primary.main', 
                  color: 'white', 
                  fontWeight: 'bold', 
                  width: column.minWidth,
                  maxWidth: column.minWidth,
                  padding: '12px 8px',
                  fontSize: '0.875rem',
                  textAlign: 'center',
                  background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, index) => (
            <TableRow 
              key={item.id || index}
              hover 
              sx={{ 
                '&:hover': {
                  bgcolor: 'action.hover',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              {columns.map((column) => (
                <TableCell 
                  key={column.key} 
                  sx={{ 
                    padding: '6px 8px',
                    width: column.minWidth,
                    maxWidth: column.minWidth,
                    borderBottom: '1px solid',
                    borderColor: 'divider'
                  }}
                >
                  {renderCell(item, index, column.key)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ItemsTableDesktop
